import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/svg/grip.svg';

var _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  width: "12",
  height: "12",
  src: _imports_0,
  alt: "grip"
}, null, -1);

var _hoisted_2 = {
  class: "item-name"
};
var _hoisted_3 = {
  style: {
    "position": "relative"
  },
  class: "w-100"
};
var _hoisted_4 = {
  key: 0,
  class: "terminal-warning"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = {
  key: 0
};

var _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner"
}, null, -1);

var _hoisted_8 = [_hoisted_7];
var _hoisted_9 = {
  key: 1
};

var _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "connected-terminal"
}, null, -1);

var _hoisted_11 = [_hoisted_10];
var _hoisted_12 = {
  key: 2
};

var _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "disconnected-terminal"
}, null, -1);

var _hoisted_14 = [_hoisted_13];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_button = _resolveComponent("el-button");

  var _component_select_card_reader = _resolveComponent("select-card-reader");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createBlock(_component_el_form, {
    model: _ctx.formData,
    "label-position": "top",
    "label-width": "120px",
    "hide-required-asterisk": true,
    class: "setting-items"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_icon, {
                size: 12,
                style: {
                  "margin-right": "5px"
                },
                class: "pointer-cursor handle"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_1];
                }),
                _: 1
              }), _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.PaymentMethodTypeToTranslatedString[_ctx.formData.id]), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: _ctx.formData.used ? 'primary' : 'default',
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.toggleStatus(true);
                }),
                onTouchstart: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.toggleStatus(true);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.enabled")), 1)];
                }),
                _: 1
              }, 8, ["type"]), _createVNode(_component_el_button, {
                type: !_ctx.formData.used ? 'primary' : 'default',
                onClick: _cache[2] || (_cache[2] = function ($event) {
                  return _ctx.toggleStatus(false);
                }),
                onTouchstart: _cache[3] || (_cache[3] = function ($event) {
                  return _ctx.toggleStatus(false);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.disabled")), 1)];
                }),
                _: 1
              }, 8, ["type"])];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_row, {
                class: "items-row w-100"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_col, {
                    span: 19,
                    class: "d-flex fl-a-c"
                  }, {
                    default: _withCtx(function () {
                      return [typeof _ctx.formData.terminal === 'string' || typeof _ctx.formData.terminal === 'undefined' ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        prop: "terminal",
                        class: "w-100"
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_select_card_reader, {
                            modelValue: _ctx.formData.terminal,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                              return _ctx.formData.terminal = $event;
                            }),
                            disabled: !_ctx.isUsed,
                            onDoParentAction: _ctx.checkSelectedTerminal
                          }, null, 8, ["modelValue", "disabled", "onDoParentAction"]), _ctx.isUsed && !_ctx.formData.terminal ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("error.no-selected-terminal")), 1)])) : _createCommentVNode("", true)])];
                        }),
                        _: 1
                      })) : _createCommentVNode("", true)];
                    }),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 5,
                    class: "d-flex fl-a-c fl-j-c"
                  }, {
                    default: _withCtx(function () {
                      return [_ctx.isUsed && _ctx.formData.terminal ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_ctx.terminalConnection === _ctx.TerminalConnectivity.Loading ? (_openBlock(), _createElementBlock("p", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true), _ctx.terminalConnection === _ctx.TerminalConnectivity.Connected ? (_openBlock(), _createElementBlock("p", _hoisted_9, _hoisted_11)) : _createCommentVNode("", true), _ctx.terminalConnection === _ctx.TerminalConnectivity.Disconnected ? (_openBlock(), _createElementBlock("p", _hoisted_12, _hoisted_14)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model"]);
}